module.exports = __webpack_public_path__ + "media/images/mobile/home/bg06-5666412650afda4ff4dd424cd4610a51.jpg";